import { Typography } from "@material-ui/core";
import React from "react";

const Logo = (props) => {
  return (
    <>
    <img
      src={"images/whitelogo.png"}
      alt="Logo"
      {...props}
      style={{ height: "50px", width: "130px", objectFit: "contain" }}
    />
     </>
  );
};

export default Logo;
